import { Component, OnInit, model, SimpleChanges, OnChanges, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { User } from '../../shared/models/user.model';
import { ProfileService } from '../../profile/services/profile.service';
import { AccessModel } from '../../core/models/access.model';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [MenuModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit, OnChanges {
  profileService = inject(ProfileService);
  service = inject(LayoutService)
  items = model<MenuItem[] | undefined>();
  visible = model<boolean>(false)

  profile = model<User | undefined>()
  access = model<AccessModel | undefined>()

  visibleWithUser = model<boolean>(false);
  visibleWithNotUser = model<boolean>(true);

  constructor() {}


  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
    this.updateItems();
  }

  update() {
    // console.log('Update User: ', this.user())
    // console.log('User: ', this.visibleWithUser())
    // console.log('Not User: ', this.visibleWithNotUser())
    if (this.profile() !== undefined) {
      this.visibleWithUser.update((value) => (value = true));
      this.visibleWithNotUser.update((value) => (value = false));
    } else if (this.profile() === undefined) {
      this.visibleWithUser.update((value) => (value = false));
      this.visibleWithNotUser.update((value) => (value = true));
    }
  }
  updateItems(): void {
    // let visible = {
    //   seguricel
    // }
    let superAdmin: boolean = false;
    if (this.profile()?.user_type?.access) {
      superAdmin = true;
    }
    const menuItems: MenuItem[] = [
      { label: 'Dashboard', icon: 'pi pi-home', route: './' },
      { label: 'Imágenes', icon: 'pi pi-list', route: './image/list', visible: this.access()?.image.actions.read },
      { label: 'Sucursales', icon: 'pi pi-list', route: './branch/list', visible: this.access()?.branch.actions.read },
      { label: 'Usuarios', icon: 'pi pi-list', route: './user/list', visible: this.access()?.user.actions.read },
      { label: 'Contratos', icon: 'pi pi-list', route: './contract/list', visible: this.access()?.contract.actions.read },
      { label: 'Roles', icon: 'pi pi-list', route: './role/list', visible: this.access()?.role.actions.read },
      { label: 'Permisos', icon: 'pi pi-list', route: './permission/list', visible: this.access()?.permission.actions.read },
      { label: 'Pantallas', icon: 'pi pi-list', route: './advertising/list', visible: this.access()?.advertising.actions.read },
      { label: 'Estadísticas de Turnos', icon: 'pi pi-list', route: './turn/', visible: this.access()?.turn.actions.read },
      { label: 'Servicios', icon: 'pi pi-list', route: './servicios/list', visible: this.access()?.servicio.actions.read },
      { label: 'Salir', icon: 'pi pi-power-off', command: () => this.profileService.logout() },
      { label: 'Alertas de Cola', icon: 'pi pi-list', route: './queue-alerts/list', visible: this.access()?.queue_alert.actions.read },
    ];
    this.items.update(value => (value = this.service.sortMenuItems(menuItems)))
    // console.log('Menu Items: ', this.items())
  }
}
